import { TXProductDetailsTemplate } from "../../../types/common/templates.types";
import { X_PRODUCT_DETAILS_TEMPLATE1 } from "./template1";
import { X_PRODUCT_DETAILS_TEMPLATE2 } from "./template2";

export const X_PRODUCT_DETAILS_TEMPLATES: TXProductDetailsTemplate = {
  ...X_PRODUCT_DETAILS_TEMPLATE1,
  ...X_PRODUCT_DETAILS_TEMPLATE2,
};
